module.exports = __webpack_public_path__ + "static/media/SLANTED FLAP X3.a398c4b4.svg";